import {Injectable, Injector, inject} from "@angular/core";
import {EntityData, EntityModel, field} from "@fedelta-pos/data-client";
import {IntegratedPaymentProvider} from './payment';

export class OrderPaymentDetailsData extends EntityData<OrderPaymentDetailsData> {
    @field provider: IntegratedPaymentProvider;
    @field cardBrand: string;
    @field cardCountry: string;
    @field cardLast4: string;
    @field paymentIntentId: string;
    @field platformPublicKey: string;
    @field platformAccountId: string;
    @field integratedPaymentConfigId: number;
    @field platformLiveMode: boolean;
    @field platformApplicationFee: number;
    @field paymentMethods: string;
}

@Injectable()
export class OrderPaymentDetailsEntityModel extends EntityModel<OrderPaymentDetailsData> {
    constructor() {
        console.log("--- OrderPaymentDetailsEntityModel");
        super(inject(Injector), OrderPaymentDetailsData);
    }

    override getResourceName(): string {
        return "app-order-payment-details";
    }
}
